import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	ownedBy: {
		id: 'project-directories.components.compass-table.cells.dependencies.popup-content.dependency-row.owner-new',
		defaultMessage: '{componentName} <text>owned by</text> {teamName}',
		description:
			'Text displaying who owns a component. Message will show like: "{componentName} owned by {teamName}".',
	},
	noOwner: {
		id: 'project-directories.components.compass-table.cells.dependencies.popup-content.dependency-row.no-owner-new',
		defaultMessage: '{componentName} <text>No owner</text>',
		description: 'Highlights that a component with name componentName has no owner.',
	},
});
